import abi from '../artifacts/contracts/Upload.sol/Upload.json'

// const dotenv = require('dotenv')
// dotenv.config({ path: '../../config.env' })

export const CONTRACT_ABI = abi.abi
export const CONTRACT_ADDRESS = '0x12a7F07Db7DE0252A42D3C6599eBBD942f38B4a2'

export const pinataApiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
export const pinata_API_key = '36ac4f29a2d92b8c0472'
export const pinata_secret_API_key = 'af261896a302b90a9fa7910c6fbc12e62a4971828cff8b71084ce2d12abdd2e9'